
class handleViewForms {
  _construct() {
    this.$form = document.querySelector('.update-scholarships-form');
    this.$status = this.$form.querySelector('[name="status"]');
  }

  _sendForm($el) {
    const self = this;
    let dataValue = $el.getAttribute('data-value');
    self.$status.setAttribute('value', dataValue);

    this.$form.submit();
  }

  init() {
    this._construct();
    const self = this;
    // --
    let $buttons = this.$form.querySelectorAll('button');
    $buttons.forEach(function($button) {
      $button.addEventListener('click', function(event) {
        event.preventDefault();
        self._sendForm($button);
      });
    });
  }
}

export default handleViewForms
